import PropTypes from "prop-types"
import React from "react"

import ImportForm from "../ImportForm"
import { ImportHistoryContextProvider } from "../ImportHistoryContext"
import ImportHistoryTable from "../ImportHistoryTable"

export default function ImportsContainer({
  currentUserId,
  availableImportTypes,
}) {
  return (
    <ImportHistoryContextProvider currentUserId={currentUserId}>
      <div className="mx-auto mt-6 max-w-7xl px-4">
        <ImportForm availableImportTypes={availableImportTypes} />
        <ImportHistoryTable />
      </div>
    </ImportHistoryContextProvider>
  )
}

ImportsContainer.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  availableImportTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
}
